<template>
    <div class="login-wrap">
        <div class="login-bg"></div>
        <div class="login-content-wrap">
            <div class="banner-wrap">
                <div class="left-wrap">
                    <div class="logo-wrap">
                        <img src="../../static/logo.png" alt="" />
                    </div>
                    <div class="project-name-wrap YouSheBiaoTiHei">{{ logoText }}</div>
                    <!-- <span class="version">{{ $version }}</span> -->
                </div>
                <div class="right-wrap">
                    <div class="language-wrap">
                        <el-select v-model="language" @change="languageChange">
                            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"
                                size="medium">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="container-wrap">
                <div class="notice-wrap">
                    <div class="notice-title-wrap bold">{{ $t('login.noticeTitle') }}</div>
                    <div class="notice-content-wrap" v-if="announce != ''" v-html="announce"></div>
                    <div class="notice-content-wrap notice-empty-wrap" v-else>
                        <div class="iconfont">&#xe6fe;</div>
                        <div class="empty-desc regular">{{ $t('login.noNoticeDes') }}</div>
                    </div>
                </div>
                <div class="login-mid-content-wrap animate__bounceInDown">
                    <!--欢迎使用空间预约系统-->
                    <div class="login-welcome-wrap">
                        <span class="bold-style medium">{{ $t('login.welcome') }}</span>
                        <span class="word regular">{{ $t('login.system') }}</span>
                    </div>
                    <!--登录表单-->
                    <div class="login-form-wrap">
                        <div>
                            <span class="title-wrap regular">{{ $t('login.loginPass') }}</span>
                        </div>
                        <div class="student-wrap">
                            <el-input :placeholder="$t('login.userNamePle')" v-model="form.username">
                                <span slot="prefix" class="iconfont">&#xe661;</span>
                            </el-input>
                        </div>
                        <div class="password-wrap">
                            <el-input :placeholder="$t('login.passwordPle')" show-password v-model="form.password">
                                <span slot="prefix" class="iconfont">&#xe62e;</span>
                            </el-input>
                        </div>
                        <div class="code-wrap">
                            <el-input :placeholder="$t('login.codePle')" v-model="form.identifyCode" ref="identifyCode"
                                @keyup.enter.native="confirmLogin">
                                <span slot="prefix" class="iconfont">&#xe60a;</span>
                                <img slot="suffix" v-if="showCaptcha" :src="captchaText" style="height: 50px;"
                                    @click="getUserCaptcha" />
                                <div slot="suffix" v-if="!showCaptcha" class="linkPointer getCode" @click="getUserCaptcha">
                                    {{ $t('login.codeGet') }}</div>
                            </el-input>
                        </div>
                        <el-button class="submit-button-wrap regular" style="margin-top: 30px;" @click="confirmLogin" :loading="loginLoding">
                          {{ languageType=='zh'? vueConfig.loginBtnZh : vueConfig.loginBtnEn }}
                        </el-button>
                        <el-button class="submit-button-wrap regular" style="margin:10px 0px;" v-if="CASLOGIN != 0" @click="gotoCas" :loading="loginLoding">
                          {{ languageType=='zh'? vueConfig.casBtnZh : vueConfig.casBtnEn }}
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {  generateCaptcha, login, getUserInfo, currentUseMake } from "../api/index";
import { encryptAes } from '@/api/aes'
export default {
    data() {
        return {
            CASLOGIN: 0,
            showCaptcha: false,
            loginLoding: false,
            logoText: this.$t('login.system'),
            captchaId: '',//验证码id
            captchaText: '',
            announce: '',//全局公告
            language: 'ZH',
            form: {
                username: "",//账号
                password: "",//密码
                identifyCode: '',//验证码
            },
            options: [
                {
                    value: 'zh',
                    label: 'ZH'
                }, {
                    value: 'en',
                    label: 'EN'
                }
            ],
            languageType: localStorageProxy.getItem("languageType") || "zh",
            vueConfig: JSON.parse(sessionStorageProxy.getItem('vueConfig')),
        }
    },
    methods: {
        gotoCas() {
            let vueConfig = JSON.parse(sessionStorageProxy.getItem('vueConfig'))
            window.location.href = `${vueConfig.CASSSERVICE}/static/sso/login?redirectUrl=${(vueConfig.VUESERVICE)}`;
        },
        //登录验证
        confirmLogin() {
            if (this.form.username == "" || this.form.password == "")
                return this.$error("学号和密码不能为空~");
            let params = {
                username: encryptAes(this.form.username),
                password: encryptAes(this.form.password),
                sysCaptchaRes: {
                    captchaId: this.captchaId,
                    captchaText: this.form.identifyCode
                }
            };
            login(params)
                .then((res) => {
                    if (res.data.status) {
                        sessionStorageProxy.setItem("token", res.data.data.token);
                        sessionStorageProxy.setItem("loginType", "login");
                        this.getCurrentBook()
                        this.getUserInfoFn();
                    } else {
                        this.getCaptcha(1);
                        if (res.data.message == "") {
                            this.$warning("此账号已被禁用,请联系管理员~");
                        } else {
                            this.$error(res.data.message);
                            if (res.data.message == "验证码错误") {
                                this.form.identifyCode = "";
                                this.$refs.identifyCode.focus();
                            }
                        }
                    }
                }).catch((err) => {
                    this.getCaptcha();
                    console.error(`登录接口Error:${err}`);
                });
        },

        //语言切换
        languageChange(e) {
            console.log(this.$i18n.locale)
            if (e == 'zh') {
              window.document.title = this.systemInfo.vueConfig.htmlTitleZh
            } else {
              window.document.title = this.systemInfo.vueConfig.htmlTitleEn
            }
            localStorageProxy.setItem("languageType", e)
            this.$i18n.locale = e
            this.$forceUpdate();
        },
        getUserCaptcha() {
            if (this.form.username == '') {
                return this.$error(this.$t('login.userNamePle'))
            } else {
                this.getCaptcha()
                this.showCaptcha = true
            }
        },
        // 获取验证码
        getCaptcha() {
            if (this.form.username == '') {
                return this.showCaptcha = false
            }
            generateCaptcha(this.form.username)
                .then(res => {
                    if (res.data.status) {
                        this.captchaId = res.data.data.captchaId;
                        this.captchaText = res.data.data.captchaText;
                    } else {
                        this.$error(res.data.message);
                    }
                })
                .catch(e => {
                    console.log("出错了", e);
                    this.$warning(this.$t('common.error'));
                });
        },
        getUserInfoFn() {
            getUserInfo({ token: sessionStorageProxy.getItem("token") }).then((res) => {
                if (res.data.status) {
                    sessionStorageProxy.setItem("userInfo", JSON.stringify(res.data.data));
                    let firstLogin = localStorageProxy.getItem("firstLogin") //首次登录系统
                    if (firstLogin == undefined) {
                        localStorageProxy.setItem("firstLogin", true) //第一次登录系统
                    }
                    if (this.$route.query.roomId) {
                        this.$router.push(`/seatInfo/${this.$route.query.roomId}/${this.$route.query.seatNum}`);
                    } else {
                        this.$router.push("/main/home");
                    }

                } else {
                    this.$error(res.data.message);
                }
            }).catch((err) => {
                console.log(`获取用户信息Error:${err}`);
                this.$error(this.$t('common.error'));
            });
        },
        // 获取当前有效预约
        getCurrentBook() {
            currentUseMake().then(res => {
                if (res.data.status) {
                    let currentBook = res.data.data == null ? {} : res.data.data
                    sessionStorageProxy.setItem("currentBook", JSON.stringify(currentBook))
                } else {
                    this.$warning(res.data.message)
                }
            }).catch(err => {
                console.error(`获取当前有效预约Error:${err}`);
                this.$warning(this.$t('common.error'))
            })
        }
    },

    created() {

    },
    mounted() {
        var vueConfig = JSON.parse(sessionStorageProxy.getItem('vueConfig'))
        this.CASLOGIN = Number(vueConfig && vueConfig.CASLOGIN || 0)
        var systemInfo = JSON.parse(sessionStorageProxy.getItem('systemInfo'))
        this.systemInfo = systemInfo
        if (systemInfo && systemInfo.agreements && systemInfo.agreements != '') {
                    this.announce = systemInfo.agreements
                }
    }
}
</script>
<style lang="less" scoped>
.login-wrap {
    height: 100vh;
    width: 100vw;
    position: relative;

    .login-bg {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        z-index: 1;
        background-image: url("../assets/images/login/bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        opacity: 0.6;
    }

    .login-content-wrap {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        z-index: 2;
        display: flex;
        flex-direction: column;
        background: transparent;

        .banner-wrap {
            display: flex;
            align-items: center;
            height: 80px;
            padding: 0px 47px;

            .left-wrap {
                display: flex;
                height: 100%;
                align-items: center;
                justify-content: flex-start;
                flex: 1;
            }

            .right-wrap {
                flex: 1;
                height: 100%;
                display: flex;
                justify-content: flex-end;
                align-items: center;
            }

            .logo-wrap {
                img {
                    display: block;
                    object-fit: contain;
                    width: 138px;
                    height: 42px;
                }
            }

            .project-name-wrap {
                color: #f4850b;
                font-size: 24px;
                margin-left: 11px;
                user-select: none;
            }

            .version {
                color: #f4850b;
                user-select: none;
                font-size: 16px;
                font-weight: bold;
                transform: translate(3px, 2px);
            }
        }

        .container-wrap {
            flex: 1;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            padding: 47px;
            background-image: url("../assets/images/login/loginBG.png");
            background-position: center center;
            background-repeat: no-repeat;
            background-size: auto 60%;

            .notice-wrap {
                margin-top: 40px;
                margin-left: 80px;
                width: 380px;
                height: 572px;
                background: url("../assets/images/login/noticeBG.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
                padding: 15px;
                padding-bottom: 20px;
                display: flex;
                flex-direction: column;

                .notice-title-wrap {
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    letter-spacing: 3px;
                    font-size: 20px;
                    padding-bottom: 10px;
                    transform: translate(0px, -5px);
                }

                .notice-content-wrap {
                    flex: 1;
                    margin-top: 10px;
                    overflow: auto;
                }

                .notice-empty-wrap {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;

                    .iconfont {
                        font-size: 80px;
                        color: #999;
                        transform: translate(0px, -50px);
                        user-select: none;
                    }

                    .empty-desc {
                        margin-top: 10px;
                        letter-spacing: 0.5px;
                        transform: translate(0px, -50px);
                        color: #666;
                        user-select: none;
                    }
                }
            }

            .login-mid-content-wrap {
                width: 413px;
                margin-right: 50px;
                margin-top: 30px;

                .login-welcome-wrap {
                    text-align: left;

                    .bold-style {
                        font-size: 34px;
                        font-weight: 500;
                        color: #333;
                    }

                    .word {
                        display: inline-block;
                        margin-left: 22px;
                        font-size: 20px;
                    }
                }

                .login-form-wrap {
                    width: 413px;
                    margin-top: 28px;
                    height: 469px;
                    background: #ffffff;
                    box-shadow: 0px 1px 11px 1px rgba(0, 0, 0, 0.1);
                    opacity: 1;
                    border-radius: 10px;
                    padding: 39px;
                    display: flex;
                    flex-direction: column;

                    .title-wrap {
                        border-bottom: 3px solid #409eff;
                        width: auto;
                        display: inline-block;
                        font-size: 17px;
                        color: #12131a;
                        font-weight: 400;
                        text-align: left;
                    }

                    .student-wrap {
                        margin-top: 34px;

                        .iconfont {
                            font-size: 17px;
                            font-weight: bold;
                        }
                    }

                    .password-wrap {
                        margin-top: 34px;
                    }

                    .code-wrap {
                        margin-top: 34px;

                        .canvas-wrap {
                            height: 51px;
                            border-radius: 0px 10px 10px 0px;
                            background: rgba(75, 129, 247, 0.7);
                            overflow: hidden;

                            img {
                                display: block;
                                height: 100%;
                            }
                        }

                        .getCode {
                            height: 100%;
                            background-color: #4b81f7;
                            color: white;
                            width: 100px;
                            border-top-right-radius: 5px;
                            border-bottom-right-radius: 5px;
                            line-height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 16px;
                        }

                        .iconfont {
                            font-size: 20px;
                        }
                    }

                    .submit-button-wrap {
                        margin-top: 50px;
                        width: 335px;
                        height: 55px;
                        background: #4b81f7;
                        border-radius: 38px 38px 38px 38px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: white;
                        font-size: 20px;
                        cursor: pointer;
                        user-select: none;
                    }
                }
            }
        }
    }
}
</style>
<style lang="less">
.login-wrap {
    .el-dialog {
        border-radius: 15px;
        padding: 20px 10px;

        .gray-btn {
            background-color: #909399;
            color: white;
            border-color: #909399;
        }
    }

    .rule-content-wrap {
        height: 400px;
        overflow: auto;

        p {
            line-height: 1.5em;
            margin-top: 10px;
        }
    }

    .language-wrap {
        .el-input--suffix .el-input__inner {
            width: 120px;
            background: transparent;
            border: none;
            font-family: "SCRegular";
            font-size: 18px;
        }

        .el-select .el-input .el-select__caret {
            color: black;
            font-size: 18px;
            font-weight: bold;
        }
    }

    .notice-content-wrap {
        p {
            font-family: "SCRegular";
            line-height: 1.35em;
            text-indent: 2em;
            color: #000007;
            font-size: 15px;
            font-weight: 400;
        }
    }

    .login-form-wrap {
        div:first-child {
            text-align: left;
        }

        .el-input__prefix {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 30px;
            color: rgba(22, 127, 255, 0.8);
            font-size: 20px;

            .iconfont {
                font-size: 18px;
            }
        }

        .el-input__suffix {
            right: 0px;
        }

        .password-wrap .el-input__suffix {
            right: 5px;
        }

        .el-input--prefix .el-input__inner {
            border-radius: 8px;
            height: 51px;
            background: #f7f8fa;
            font-size: 14px;
            font-weight: 400;
            padding-left: 35px;
            color: #8a8ea6;
        }

        .el-input--suffix .el-input__inner {
            border-radius: 8px;
            height: 51px;
            background: #f7f8fa;
            font-size: 14px;
            font-weight: 400;
            color: #8a8ea6;
        }
    }

    /* 滚动条整体部分，可以设置宽度 */
    .notice-content-wrap::-webkit-scrollbar {
        width: 0px;
        height: 0px;
    }

    .notice-content-wrap::-webkit-scrollbar-thumb {
        border-radius: 0px;
        background: #409eff;
    }

    .notice-content-wrap::-webkit-scrollbar-track {
        border-radius: 0px;
        background: #ededed;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue